<template>
  <el-dialog :title="'签收情况'" :visible.sync="dialogFormVisible" custom-class="medium-dialog" center :append-to-body="true"
             :close-on-click-modal="false"><el-col :span="24">
      <div>
        <el-table
          :data="tableData"
          :height="tableHeight(190)"
          size="mini"
          stripe
          border
          style="width: 100%;">
          <el-table-column
            width="60"
            label="序号"
            align="center">
            <template slot-scope="scope">
              {{1+scope.$index+(pagination.currentPage-1)*pagination.pageSize}}
            </template>
          </el-table-column>

          <el-table-column
            prop="senduname" width="100"
            label="发送人"
            align="left"
            header-align="left"
          >
          </el-table-column>
          <el-table-column
            align="center"
            label="发送日期" width="150">
            <template slot-scope="scope">
              {{(scope.row.senddate || "")}}
            </template>
          </el-table-column>
          <el-table-column
            prop="receiveuname"
            label="接收人"
            align="left"
            header-align="center"
          >  <template slot-scope="scope">
            {{scope.row.deptname?('【'+scope.row.deptname+'】'):''}}{{scope.row.receiveuname}}
          </template>
          </el-table-column>
            <el-table-column
              prop="feedbacktimes"
              label="未读"
              align="left" width="60"
              header-align="center"
            >
          </el-table-column>
            <el-table-column
              align="center"
              label="签收日期" width="150">
              <template slot-scope="scope">
                {{(scope.row.signdate || "")}}
              </template>
          </el-table-column>
          <el-table-column
            align="center"
            label="最近反馈日期" width="150">
            <template slot-scope="scope">
              {{(scope.row.feedbackdate || "")}}
            </template>
          </el-table-column>

        </el-table>

        <div class="foot" >
          <Pagination ref="pagination1" @bindgrid="bindGrid" :pagination="pagination"></Pagination>
        </div>


      </div>
    </el-col>

    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
    </div>
  </el-dialog>
</template>

<script>
  import {getExchangeListData} from '@/api/oa/exchange';

  export default {
    name: 'HelloWorld2222',
    data() {
      return {
        dialogFormVisible: false,
        pagination: {
          currentPage: 1,
          pageSize: 100,
          total: 0
        },
        exchangeguid:'',
        tableData: [],
        controlData: {}
      }
    },
    props:{
      statuses:{
        default:""
      },
    },
    methods: {
      bindGrid(exchangeguid) {
        getExchangeListData({
          offset: (this.pagination.currentPage - 1) * this.pagination.pageSize,
          limit: this.pagination.pageSize,
          exchangeguid: this.exchangeguid
        }).then(response => {
          this.tableData=response.data.obj.rows;
          this.pagination.total = response.data.obj.total;
        }).catch((error) => {
          console.log(error);
        });

      },

      show(exchangeguid){
        this.exchangeguid=exchangeguid;
        this.dialogFormVisible=true;
        this.tableData=[];
        this.bindGrid(exchangeguid);

      },
      hide(){
        this.dialogFormVisible=false;
      }

    },
    mounted() {

    },
    components: {

    }

  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>


  /*.el-table td, .el-table div, .el-table .cell {*/
  /*line-height: 23px;*/
  /*padding: 0px;*/
  /*color: red;*/
  /*}*/

</style>



// WEBPACK FOOTER //
// src/components/oa/exchange/ExchangeList.vue